import { useEffect, useRef } from 'react';
import Stats from 'stats.js';

const FPSMonitor = () => {
  const statsRef = useRef(null);

  useEffect(() => {
    const stats = new Stats();
    stats.showPanel(0); // Показати панель FPS
    document.body.appendChild(stats.dom);

    statsRef.current = stats;

    const animate = () => {
      stats.begin();
      // Моніторинг
      stats.end();
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);

    return () => {
      if (statsRef.current) {
        document.body.removeChild(statsRef.current.dom);
      }
    };
  }, []);

  return null;
};

export {
  FPSMonitor
};